import Vue from "vue";
Vue.mixin({
  methods: {
    isUndefined (obj) {
      if (obj == undefined){
        return true
      } else{
        return false;
      }
    },
    isNull (obj) {
      if (obj == undefined){
        return true
      } else{
        return false;
      }
    },
    isNullOrEmpty (obj) {
      if (obj == undefined){
        return true
      } else if (obj.toString().trim() == ""){
        return true;
      } else{
        return false;
      }
    },
    isEq(a, b){
      if(this.isUndefined(a) || this.isUndefined(b)){
        return false
      };
      if(a.toString().trim() == b.toString().trim()){
        return true
      } else{
        return false
      }
    },
    nvl(value) {
      if (value == undefined || isNaN(value)) {
        return 0;
      } else {
        return value;
      }
    },
  }
});